import { render, staticRenderFns } from "./vueEmiParametrs.vue?vue&type=template&id=323dffc9"
import script from "./vueEmiParametrs.vue?vue&type=script&lang=js"
export * from "./vueEmiParametrs.vue?vue&type=script&lang=js"
import style0 from "./vueEmiParametrs.vue?vue&type=style&index=0&id=323dffc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports